/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Sorting options for messages
 */
export enum MessageSort {
    DEFAULT = 'DEFAULT',
    SENT_TO = 'SENT_TO',
    READS = 'READS',
    RESPONSES = 'RESPONSES',
    PPV_BOUGHT = 'PPV_BOUGHT',
}
